export default "__VITE_ASSET___Cv$X2_w__"